define([
    'moment'
], function (
    Moment
    ) {
    var FORMAT = 'YYYY-MM-DDTHH:mm:ss[Z]';

    return {
        loads: function(str) {
            Moment(str);
        },
        dumps: function(m) {
            return m.format(FORMAT);
        },
        now: function() {
            return Moment().utc();
        }
    }
});



// WEBPACK FOOTER //
// ./common/util/time.js